The response from the `replayWebhookSubscription` mutation.
